import React from 'react';

import { block } from 'bem-cn';

import { LANGUAGES } from '../../constants';
import useLocalizedStrings from '../../hooks/useLocalizedStrings';
import { ImmutableMapItem, PionType } from '../../type';
import { withStopPropagation } from '../../utils';

import './tip-pion.scss';

const b = block('tip-pion');

export const translations = {
  [LANGUAGES.EN]: {
    markAsRead: 'Mark as read',
  },
  [LANGUAGES.SV]: {
    markAsRead: 'Markera som läst',
  },
};

export type TipPionPropsType = {
  pion: Pick<
    PionType,
    keyof ImmutableMapItem | 'id' | 'read' | 'title' | 'content' | 'image'
  >;

  onPionClick: () => void;
  onReadButtonClick: (event: any) => void;
  lang: string;
};

const TipPion = ({
  pion,
  onPionClick = () => {},
  onReadButtonClick = () => {},
  lang,
}: TipPionPropsType) => {
  const strings = useLocalizedStrings(translations, lang);

  return (
    <div
      className={b({
        read: pion.get('read'),
        elevated: pion && pion.has('read') && !pion.get('read'),
      })}
      data-pionid={pion.get('id')}
    >
      <div className={b('header')}>
        <div className={b('header-block')}>
          <div className={b('icon')} />
          <h3 className={b('title')}>{pion.get('title')}</h3>
        </div>

        {!pion.get('read') && (
          <div
            className={b('header-button')}
            onClick={withStopPropagation(onReadButtonClick)}
          >
            {strings.markAsRead}
          </div>
        )}
      </div>
      <div className={b('content')} onClick={onPionClick}>
        {pion.getIn(['image', 'smallUrl']) && (
          <div className={b('image-wrapper')}>
            <img
              src={pion.getIn(['image', 'smallUrl'])}
              data-testid='tip-pion-image'
              alt=''
            />
          </div>
        )}
        {pion.get('content')}
      </div>
    </div>
  );
};

export default TipPion;
